import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const StyledDiv = styled.div`
  .legal {
    color: #777;
    a {
      color: #444;
    }
  }
`;

/**
 * Recaptcha legal copy required when hiding the recaptcha badge.
 */
const RecaptchaLegal: React.FC<ComponentProps<typeof StyledDiv>> = props => {
  const { className, ...divProps } = props;
  const classes = ['recaptcha-legal'];
  if (className) classes.push(className);
  return (
    <StyledDiv className={classes.join(' ')} {...divProps}>
      <Typography variant='caption' className='legal'>
        This site is protected by reCAPTCHA and the Google{' '}
        <a
          href='https://policies.google.com/privacy'
          target='_blank'
          rel='noreferrer'
        >
          Privacy Policy
        </a>{' '}
        and{' '}
        <a
          href='https://policies.google.com/terms'
          target='_blank'
          rel='noreferrer'
        >
          Terms of Service
        </a>{' '}
        apply.
      </Typography>
    </StyledDiv>
  );
};

export default RecaptchaLegal;
